import { Injectable } from '@angular/core';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
@Injectable({
    providedIn: 'root'
})
export class LocalKlevuSearchService extends KlevuSearchService {

    override isPageId(id: string): boolean {
        return id.includes('pageid');
    }

    override get redirects(): KlevuSearch.IKeywordUrlMap[] | undefined {
        const redirects = super.redirects;
        redirects?.map(redirect => {
            redirect.url = redirect.url
                .replace(new RegExp('^' + 'https://www.lemieuxproducts.com/'), '/')
                .replace(new RegExp('^' + this.app.url.storeUrl.replace(this.app.multisite.base, '/')), '/');
        });
        return redirects;
    }
}
